import type { ByDriverRow } from '../alertTypes'
import { EntityRankView, type EntityRankConfig } from './EntityRankView'
import type { ViewProps } from './viewKit'

const CONFIG: EntityRankConfig<ByDriverRow> = {
  path: '/by-driver',
  idColumn: 'driver_label',
  filterKey: 'driver',
  noun: { one: 'driver', many: 'drivers' },
  spreadColumn: 'vehicles',
  columns: [
    'driver_label', 'alerts', 'critical', 'warn', 'night_alerts', 'vehicles', 'kinds', 'top_kind',
    'km', 'alerts_per_100km', 'first_ts', 'last_ts',
  ],
  tableId: 'alerts-by-driver',
  exportName: 'alerts-by-driver',
  title: 'Alerts by driver',
  noData: {
    title: 'No alerts in this window',
    body: 'Nothing fired for this site between these dates. Widen the window, or check the pipeline is running before reading this as a clean week.',
  },
}

/** Per-driver alert profile. Driver comes from the TIMS spell at the alert's time
 *  (v_vehicle_driver_spell) -- 'unassigned' is a real row, not a gap to hide: it is the
 *  share of alerts nobody can be coached on. */
export function DriversView(props: ViewProps): JSX.Element {
  return <EntityRankView<ByDriverRow> {...props} config={CONFIG} />
}
